var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "download-btn-box download-btn-box-big" }, [
    _c(
      "div",
      {
        staticClass: "download-btn",
        class: {
          disabled:
            _vm.processingDownload === true ||
            _vm.currentJob.state === "failed" ||
            _vm.currentJob.state === "not_found",
        },
      },
      [
        _c(
          "a",
          {
            staticClass:
              "d-flex gap-10px align-items-center download-btn-main download-btn-primary",
            attrs: { href: _vm.downloadLink },
            on: { click: _vm.downloadJob },
          },
          [
            !_vm.processingDownload
              ? _c("i", { staticClass: "far fa-download" })
              : _vm._e(),
            _vm._v(" "),
            _vm.processingDownload
              ? _c("i", { staticClass: "fa fa-spin btn-loading-animation" })
              : _vm._e(),
            _vm._v("\n    " + _vm._s(_vm._f("trans")("Download")) + "\n    "),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "download-btn-dropdown",
            on: {
              click: function ($event) {
                _vm.dropdownActive = !_vm.dropdownActive
              },
            },
          },
          [
            !_vm.dropdownActive
              ? _c("i", { staticClass: "far fa-chevron-down" })
              : _vm._e(),
            _vm._v(" "),
            _vm.dropdownActive
              ? _c("i", { staticClass: "far fa-chevron-up" })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.dropdownActive &&
        _vm.currentJob.state !== "failed" &&
        _vm.currentJob.state !== "not_found" &&
        _vm.currentJob.state !== "processing"
          ? _c("div", { attrs: { id: "download-dropdown" } }, [
              _c("div", { staticClass: "dropdown-item" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                    attrs: { id: "dropboxButton", title: "Download as ZIP" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadJobAsZip.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("trans")("Download as ZIP")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-item" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                    attrs: {
                      id: "dropboxButton",
                      title: "Choose one or more files from Dropbox",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.uploadJobToDropbox.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "px-75" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 43 40",
                            version: "1.1",
                            width: "15px",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                              fill: "#007EE5",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("trans")("Upload to Dropbox")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.uploadJobToGdrive.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                      attrs: {
                        id: "gdriveButton",
                        title: "Choose one or more files from Google Drive",
                      },
                    },
                    [
                      _c("span", { staticClass: "px-75" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15px",
                              viewBox: "0 0 87.3 78",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                                fill: "#0066da",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                                fill: "#00ac47",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                                fill: "#ea4335",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                                fill: "#00832d",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                                fill: "#2684fc",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                                fill: "#ffba00",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("trans")("Upload to Google Drive")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "px-75" }, [
      _c("i", { staticClass: "far fa-file-archive" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }